import './page-title.scss'
import type { FC } from 'react'
import { memo } from 'react'

export interface PageTitleProps {
    text: string | undefined
    hide?: boolean
    className?: string
}

export const PageTitle: FC<PageTitleProps> = memo(props => {
    const { text, hide, className = '' } = props
    if (!text || hide) return null

    return <h1 className={`page-title container-lg-padding ${className}`}>{text}</h1>
})
